// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Qh","hasBadge":"e_Rh","bottomLine":"e_Sh","imageContainer":"e_Th","image":"e_Uh","header":"e_Vh","title":"e_Wh","score":"e_Xh"};